// extracted by mini-css-extract-plugin
module.exports = {"label-column":"_2533o3ARAUq1xgGNOd68Cd","data-column":"_2WVz9-VTbgicuNzZo9Vc_o"};